module.exports = __webpack_public_path__ + "img/pauli-x-root-19.38315e63.svg";